/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailableFiltersResponseAvailableFiltersInner
 */
export interface AvailableFiltersResponseAvailableFiltersInner {
    /**
     * 
     * @type {string}
     * @memberof AvailableFiltersResponseAvailableFiltersInner
     */
    field: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AvailableFiltersResponseAvailableFiltersInner
     */
    values: Array<string>;
}

/**
 * Check if a given object implements the AvailableFiltersResponseAvailableFiltersInner interface.
 */
export function instanceOfAvailableFiltersResponseAvailableFiltersInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "values" in value;

    return isInstance;
}

export function AvailableFiltersResponseAvailableFiltersInnerFromJSON(json: any): AvailableFiltersResponseAvailableFiltersInner {
    return AvailableFiltersResponseAvailableFiltersInnerFromJSONTyped(json, false);
}

export function AvailableFiltersResponseAvailableFiltersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableFiltersResponseAvailableFiltersInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'field': json['field'],
        'values': json['values'],
    };
}

export function AvailableFiltersResponseAvailableFiltersInnerToJSON(value?: AvailableFiltersResponseAvailableFiltersInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'field': value.field,
        'values': value.values,
    };
}

